export var reduxKey = '@@Writer';
export var READING_SPEED = 200; // wpm
//# sourceMappingURL=constants.js.map